import React, { forwardRef } from 'react';
import MUICardActions, {
  CardActionsProps as MUICardActionsProps,
} from '@material-ui/core/CardActions';

export interface CardActionsProps extends MUICardActionsProps {}

const CardActions = forwardRef<HTMLDivElement, CardActionsProps>((props, ref) => {
  return <MUICardActions {...props} ref={ref} />;
});

CardActions.displayName = 'CardActions';

export default CardActions;
